import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';

export class StatusEventSignalDisplayDetails {

  originalValue: string;
  values: StatusEventDetails[];

  constructor(originalValue: string, values: StatusEventDetails[]) {

    this.originalValue = originalValue;
    this.values = values;

  }
}
